import React from "react";
import "./style.css";

/**
 * Disegna la card di un widget solitamente la card su DBOX si divide in 3 sul 100% di spazio disponibile
 * usiamo il type per capire in quanto dividere lo spazio es. 1 su 4 colonne oppure 2 su 3 colonne etc..
 * Il default lo etichetterei come box1_3 se voglio dividere per 3 e prendere 1 sola colonna box2_3 se voglio
 * che il box occupi 2 colonne su 3
 */
const Card = props => {
  const {
    children,
    footer,
    isCentered,
    onClick,
    titleWidget,
    iconWidget,
    type,
    background,
    contentType,
    customTitle,
    style
  } = props;

  return (
    <div
      className={"cardSkeleton " + type}
      onClick={onClick ? onClick : () => {}}
    >
      {titleWidget ? (
        <div className={customTitle ? "titleCard " + customTitle : "titleCard"}>
          {titleWidget}{iconWidget}
        </div>
      ) : null}
      <div
        style={style}
        className={
          contentType
            ? contentType
            : isCentered
              ? "contentCentered"
              : !background
                ? "contentBox "
                : "contentBox redBackground"
        }
      >
        {children}
      </div>
      {footer ? (
        <div
          className={!background ? "footerBoxCard" : "footerBox redBackground"}
        >
          {footer}
        </div>
      ) : null}
    </div>
  );
};

export default Card;
